export default {
    title: 'Mein User',

    email: 'E-Mail',
    customName: 'Anzeigename',
    firstname: 'Vorname',
    role: 'Rolle',
    role_name: 'Rolle',
    created_at: 'Erstellt am',
    id: 'ID',
    impersonate: 'Support geben',

    qf_onlyEmployees: 'Nur Mitarbeiter'
}
